import { useCallback, useMemo } from 'react';
import { createSearchParams, useNavigate, useSearchParams } from 'react-router-dom';

interface UseSiteMapFocusProps {
  paramKey: string;
  pathname: string;
}

interface UseSiteMapFocusReturn {
  value: number | undefined;
  focus: (id: number) => void;
}

export const useSiteMapFocus = ({
  paramKey,
  pathname,
}: UseSiteMapFocusProps): UseSiteMapFocusReturn => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const value = useMemo<number | undefined>(() => {
    const stringId = searchParams.get(paramKey);
    if (stringId) {
      const parsedId = Number(stringId);
      if (!isNaN(parsedId)) {
        return parsedId;
      }
    }
  }, [searchParams, paramKey]);

  const focus = useCallback(
    (newValue: number): void => {
      if (value !== newValue) {
        navigate({
          pathname,
          search: createSearchParams({ [paramKey]: newValue.toString() }).toString(),
        });
      }
    },
    [navigate, value, pathname, paramKey],
  );

  return { value, focus };
};
